import { SEOPageAttributes } from "../../../typings/SEO"

const title = {
	de: "Impressum | SafeHero.com 🛡️",
	en: "Imprint | SafeHero.com 🛡️",
	pl: "Impressum | SafeHero.com 🛡️",
}

const description = {}

const openGraph = {}

const twitter = {}

const imprint: SEOPageAttributes = {
	title,
	description,
	openGraph,
	twitter,
}

export default imprint
